import './App.css';
import Footer from './Footer';

import Todolist from './Todolist';

function App() {
  return (
    <>
      <div className="App">
        <Todolist />
        <Footer/>
      </div>
    </>
  );
}

export default App;
